export default "__VITE_ASSET__0yKEs4Wq__"